import React, { useState } from "react";
import { Transition } from "@headlessui/react"; // For smooth animations

const FAQ = () => {

  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(index === openIndex ? null : index);
  };

  const faqs = [
    {
      question: 'What Are the Steps to Secure Permanent Residency in Canada with Visa World?',
      answer:
        'Acquiring Canadian permanent residency through Visa World involves various essential factors, including age, educational qualifications, professional experience and language proficiency. The immigration program you choose also plays a key role in your application’s success. Additionally, having a background in investments or business ties with Canada can strengthen your application. Visa World customizes its services to maximize your chances of securing Canadian permanent residency.',
    },
    {
      question: 'What Are the Eligibility Criteria, Processing Time and Age Restrictions for Canadian Citizenship through Visa World?',
      answer:
        'To qualify for Canadian citizenship with Visa World, applicants must be at least 18 years old. For minors, a parent or guardian who holds Canadian citizenship can submit an application on their behalf. Applicants must also meet a residency requirement, having lived in Canada for a minimum of three years. Demonstrated proficiency in either English or French is required, as these are Canada’s official languages. A clean criminal record is necessary, as any past offenses may delay or disqualify an application.',
    },
    {
      question: 'Who Is Eligible for a Canadian Visa with Visa World?',
      answer:
        'Visa World offers Canadian Immigration (Permanent Resident) Visas to individuals from diverse backgrounds. This includes skilled workers under both federal and provincial categories, individuals with prior work or study experience in Canada, as well as business professionals eligible for economic immigration programs. Furthermore, Canadian citizens and permanent residents can sponsor close family members for immigration. Asylum seekers and those applying on humanitarian grounds may also be eligible for permanent residence.',
    },
    {
      question: 'What Is the Express Entry System Used by Visa World?',
      answer:
        'The Express Entry system at Visa World is a digital platform designed to manage applications for Canadian immigration. It is not an immigration program but a tool that facilitates the selection of applicants from various Canadian economic immigration streams, including the Federal Skilled Worker Class, Federal Skilled Trades Class, Canadian Experience Class and some Provincial Nominee Programs (PNPs). This system ensures a faster selection process for skilled candidates who meet the necessary qualifications.',
    },
    {
      question: 'How Does the Comprehensive Ranking System (CRS) Work with Visa World?',
      answer:
        'The Comprehensive Ranking System (CRS) used by Visa World is a points-based approach that ranks candidates applying for Canadian immigration. It evaluates applicants based on several factors, including age, education, work experience, language ability and other human capital characteristics. The CRS helps the Canadian government determine which candidates should receive Invitations to Apply (ITA) for permanent residency.',
    },
    {
      question: 'How Are Points Calculated in the CRS System with Visa World?',
      answer:
        'Candidates in the Express Entry pool can earn up to 1,200 points in total, with points allocated as follows: \n' +
        'Core Human Capital Factors (up to 500 points): Age, education, language proficiency and work experience.\n' +
        'Skill Transferability Factors (up to 100 points): Points are awarded based on combinations of core factors.\n' +
        'Provincial Nomination (600 points).',
    },
    {
      question: 'What Are Provincial Nominee Programs (PNPs) at Visa World?',
      answer:
        'Provincial Nominee Programs (PNPs) allow individual provinces in Canada to nominate candidates who meet their specific economic and labor market needs. Every province has its own criteria for selection. The regions that participate in PNPs include Alberta, British Columbia, Manitoba, New Brunswick, Newfoundland and Labrador, Northwest Territories, Nova Scotia, Ontario, Prince Edward Island, Saskatchewan and Yukon.',
    },
    {
      question: 'How Does Age Impact My CRS Score with Visa World?',
      answer:
        'Age plays a crucial role in the CRS points calculation. Candidates between the ages of 20 and 29 receive the maximum points for age. Those above the age of 45, however, do not receive any age-related points. That said, other factors such as education, work experience and language skills can help compensate for the age factor.',
    },
    {
      question: 'Is a Provincial Nomination Necessary for Canadian Immigration with Visa World?',
      answer:
        'No, a provincial nomination is not a requirement for Canadian immigration. While a nomination can add 600 CRS points, significantly improving your chances, it is not mandatory. Candidates can still apply for permanent residency through federal immigration programs.',
    },
    {
      question: 'What Are the Benefits of the Provincial Nominee Program (PNP) with Visa World?',
      answer:
        'The Provincial Nominee Program offers several advantages: \n' +
        'Additional 600 CRS points for enhanced nominations.\n' +
        'Quicker processing times compared to other pathways.\n' +
        'Alternative routes to permanent residency.',
    },
    {
      question: 'Can I Apply Directly to a Province for a Provincial Nominee Program (PNP) through Visa World?',
      answer:
        'Yes, candidates can apply directly through the Provincial Nominee Programs (PNPs) either through the regular application process or via the Express Entry system. Visa World helps assess your profile to identify the best pathway for your immigration goals.',
    },
    {
      question: 'What Documents Are Needed for a Canada Study Visa with Visa World?',
      answer:
        'Essential documents for a Canada Study Visa application include: \n' +
        'Letter of acceptance from a recognized Canadian educational institution.\n' +
        'Proof of proficiency in English (such as IELTS scores).\n' +
        'Valid passport and academic credentials.\n' +
        'Proof of financial support and medical clearance.',
    },
    {
      question: 'Is an Educational Credential Assessment (ECA) Required for the Express Entry Process with Visa World?',
      answer:
        'Yes, an Educational Credential Assessment (ECA) is mandatory for applicants under the Federal Skilled Worker Class. The ECA evaluates foreign educational qualifications and compares them to Canadian standards to determine their equivalency.',
    },
    {
      question: 'What Is the Canadian Business Class with Visa World?',
      answer:
        'The Canadian Business Class is designed for individuals interested in contributing to Canada’s economy through investment or entrepreneurship. It includes: \n' +
        'Immigrant Investors: Those willing to make financial investments in Canada’s economy.\n' +
        'Entrepreneurs: Individuals looking to start or acquire businesses in Canada.\n' +
        'Self-Employed Persons: Those who plan to engage in self-employment and contribute economically.',
    },
    {
      question: 'Who Is Eligible for Family Sponsorship with Visa World?',
      answer:
        'Family members such as spouses, dependent children, parents and orphaned relatives under 18 years old are eligible for sponsorship. Visa World helps ensure all the necessary sponsorship requirements are met for successful applications.',
    },
    {
      question: 'What Are the Financial Requirements for Sponsoring a Family Member with Visa World?',
      answer:
        'Sponsors must demonstrate financial capacity to support the family members they wish to sponsor, except for spouses, common-law partners, or dependent children.',
    },
    {
      question: 'What Are the Steps to Apply for CRS with Visa World?',
      answer:
        'The process involves several steps: taking the IELTS exam, obtaining an Educational Credential Assessment (ECA), creating an Express Entry profile, gathering necessary documentation, receiving an Invitation to Apply (ITA), completing a medical examination and visa stamping.',
    },
  ];
const [isOpen, setIsOpen] = useState(false);

  const toggleAnswer = () => {
    setIsOpen(!isOpen);
  };
  return (
    <>
   <div className="flex items-center justify-center py-20 w-full flex-col">
  {isOpen && (
    <div className="mb-6 bg-gray-100 text-black p-4 w-3/4 items-center justify-center  text-lg rounded-md shadow-md">
      <p>
        <br />
        - Second-largest country globally with 10 provinces and 3 territories.<br />
        - Renowned for its multicultural diversity and quality of life.<br />
        - Offers a robust economy, top-notch education and excellent career opportunities.<br />
        - Transparent, merit-based immigration system for skilled professionals.<br />
        - Diverse climate with cold winters and warm summers.<br />
        - Federal programs support immigrants in job placement and social integration.<br />
        Embark on your journey to Canada and explore endless opportunities with Visa World!
      </p>
    </div>
  )}
  <button
    onClick={toggleAnswer}
    className="bg-blue-600 text-white text-center text-md justify-center  md:w-96 font-semibold py-3 w-2/2 px-6 rounded-full hover:bg-blue-700 transition duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 flex items-center"
  >
   Why Choose Canada?
    <svg
      className={`ml-3 w-4 h-4 transform transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M12 5v14M5 12l7 7 7-7"></path>
    </svg>
  </button>
</div>

      <div className="mx-auto max-w-5xl p-6 bg-white rounded-lg">
        <h2 className="text-4xl text-center font-semibold text-[#011473] mb-4">
          FAQ's
        </h2>
      </div>

      <div className="max-w-5xl mx-auto p-6">
        {faqs.map((faq, index) => (
          <div key={index} className="mb-4 border rounded-lg overflow-hidden shadow-sm">
            <button
              className={`w-full flex justify-between items-center text-left px-4 py-3 font-semibold ${
                openIndex === index ? "bg-blue-600 text-white" : "bg-gray-100"
              }`}
              onClick={() => toggleFAQ(index)}
            >
              {faq.question}
              <span
                className={`transform transition-transform ${
                  openIndex === index ? "rotate-180" : "rotate-0"
                }`}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  className="w-5 h-5"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </span>
            </button>
            <Transition
              show={openIndex === index}
              enter="transition-all duration-200 ease-out"
              enterFrom="max-h-0 opacity-0"
              enterTo="max-h-96 opacity-100"
              leave="transition-all duration-200 ease-in"
              leaveFrom="max-h-96 opacity-100"
              leaveTo="max-h-0 opacity-0"
            >
              <div className="px-4 py-3 bg-white text-gray-700">
                {faq.answer}
              </div>
            </Transition>
          </div>
        ))}
      </div>
      
    </>
  );
};

export default FAQ;




